import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import Logo from 'js/components/Logo'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import HamburgerMenu from './HamburgerMenu'
import LSButton from 'js/components/LSButton'
import './styles.scss'
import { hamburgerMenu } from 'js/featureFlags'
import { APP_STORE_LINK } from 'js/pages/LandingPages/content'
import LanguageSwitcher from 'js/components/Header/LanguageSwitcher'
import { datoLocaleToLanguage } from 'js/datoLocales'

type HeaderProps = {
  inverted?: boolean
  signupLinkText: string
  downloadLinkText: string
  locales: string[]
}

const Header = ({
  inverted = true,
  signupLinkText,
  downloadLinkText,
  locales,
}: HeaderProps) => {
  return (
    <Container>
      <header className="pt-16 lg:pt-32">
        <nav className="relative  py-12 ">
          <ul className="flex items-center justify-between">
            <div className="flex items-center">
              <HamburgerMenu hidden={!hamburgerMenu} inverted={inverted} />
              <Logo inverted={inverted} />
            </div>
            <div className="relative z-10 flex items-center lg:w-auto">
              <LanguageSwitcher
                languages={locales.map(
                  (locale) => datoLocaleToLanguage[locale] || 'en',
                )}
              />
              <LSButton
                link={true}
                href="/signup?code=50web23"
                className="mr-0 hidden lg:block"
                upperCase
                variant="primary"
                size="small"
                onClick={() =>
                  pushToDataLayer({
                    event: 'click_event',
                    click_type: 'button',
                    click_text: 'sign up now',
                    action: undefined,
                  })
                }
              >
                {signupLinkText}
              </LSButton>
              <LSButton
                link
                href={APP_STORE_LINK}
                className="mr-0 block w-auto lg:hidden"
                upperCase
                variant="primary"
                size="small"
                onClick={() =>
                  pushToDataLayer({
                    event: 'click_event',
                    click_type: 'button',
                    click_text: 'download',
                    action: undefined,
                  })
                }
              >
                {downloadLinkText}
              </LSButton>
            </div>
          </ul>
        </nav>
      </header>
    </Container>
  )
}

export default Header
